import { Box } from "@mui/material";
import { MRT_RowSelectionState, MRT_TableInstance } from "material-react-table";
import { useState, useEffect } from "react";

import AddWBSEntry from "@/features/projectScope/components/buttons/AddWBSEntry";
import EditProjectScope from "@/features/projectScope/components/buttons/editWBSEntry";
import { WBSEntryViewModel } from "@/shared/context/projectWBS/projectWBSModel";
import findId from "@/shared/utils/getId";

import DeleteWBSEntry from "../buttons/DeleteWBSEntry";

export default function ProjectScopeToolbar({
  rowSelection: initialRowSelection,
  tableInstanceRef,
  data,
}: {
  rowSelection: MRT_RowSelectionState;
  tableInstanceRef: MRT_TableInstance<WBSEntryViewModel>;
  data: WBSEntryViewModel;
}) {
  const [selectedRowIdsSet, setSelectedRowIdsSet] = useState<string[]>([]);

  useEffect(() => {
    const newSelectedIds = Object.keys(initialRowSelection).filter(
      (row_id) => initialRowSelection[row_id]
    );
    setSelectedRowIdsSet(newSelectedIds);
  }, [initialRowSelection]);

  const clearRowSelection = () => {
    setSelectedRowIdsSet([]);
    tableInstanceRef.resetRowSelection();
  };
  const row = findId(selectedRowIdsSet[0], data.children);

  if (selectedRowIdsSet.length > 0)
    return (
      <Box sx={{ marginLeft: "auto", display: "flex", marginBottom: "1rem" }}>
        {row && (
          <>
            {row.level < 3 && (
              <AddWBSEntry clearRowSelection={clearRowSelection} wbsEntry={row} />
            )}
            <EditProjectScope WBSEntry={row} />
          </>
        )}
        <DeleteWBSEntry
          clearRowSelection={clearRowSelection}
          rowSelection={selectedRowIdsSet}
        />
      </Box>
    );

  return (
    <Box sx={{ marginLeft: "auto", display: "flex", marginBottom: "1rem" }}>
      {data && <AddWBSEntry clearRowSelection={clearRowSelection} wbsEntry={data} />}
    </Box>
  );
}
